import * as React from 'react';
import { SaveButton, Toolbar } from 'react-admin';
import { Stack, Button } from '@mui/material';

const style = {
    float: 'right',
    right: '20px',
};

/** Props for {@link MyToolbar}. */
interface MyToolbarProps {
    /** Called when the "Close" button is clicked. */
    onCancel: () => void;
    /** True: disables the "Save" button (e.g. while a submit is in-flight). */
    load: boolean;
}

/** Form toolbar for the Source Variable create/edit form: Save (react-admin) and Close buttons. */
const MyToolbar: React.FC<MyToolbarProps> = ({ onCancel, load }) => {
    return (
        <Toolbar sx={style}>
            <Stack direction="row" spacing={2}>
                <SaveButton disabled={load} label="Save" size="small" />
                <Button onClick={onCancel} variant="outlined" size="small">
                    Close
                </Button>
            </Stack>
        </Toolbar>
    );
};

export default MyToolbar;
